import { ConcreteEncodable } from "./ConcreteEncodable";

import { FixingOrderModificationRequestImplEncoder } from "../../encoder/FixingOrderModificationRequestImplEncoder";

import * as CubiqTS from "../../index";
import { FixingOrderModificationRequest } from "../FixingOrderModificationRequest";

export class FixingOrderModificationRequestImpl
  extends ConcreteEncodable
  implements FixingOrderModificationRequest
{
  public static enType: string = "com.bcdfx.model.event.FixingOrderModificationRequestImpl";

  /*FID=1*/
  public fixingOrderData: CubiqTS.FixingOrderRequestData | null = null;
  /*FID=2*/
  public clientTrader: string;
  /*FID=3*/
  public stpHold: boolean;
  /*FID=4*/
  public privateFg: boolean;
  /*FID=5*/
  public savedOrder: boolean;
  /*FID=6*/
  public oboUser: string;
  /*FID=100*/
  public messageId: string;
  /*FID=101*/
  public cancelAndReplace: boolean;
  /*FID=102*/
  public privatisedRequest: boolean;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = FixingOrderModificationRequestImplEncoder.Instance;
    this.setEncodableType(FixingOrderModificationRequestImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "FixingOrderModificationRequestImpl[" +
      "fixingOrderData=" +
      this.fixingOrderData +
      "clientTrader=" +
      this.clientTrader +
      "stpHold=" +
      this.stpHold +
      "privateFg=" +
      this.privateFg +
      "savedOrder=" +
      this.savedOrder +
      "oboUser=" +
      this.oboUser +
      "messageId=" +
      this.messageId +
      "cancelAndReplace=" +
      this.cancelAndReplace +
      "privatisedRequest=" +
      this.privatisedRequest +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
